<template>
    <div class="tabPage" :style="isHeight?'height:41px':''">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane
                v-for="item in tabsArray"
                :key="item.id"
                :label="$t(item.label)"
                :name="item.sortNum"
            />
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        tabsArray:{
            type:Array,
            default:()=>[]
        },
        isHeight:{
            type:Boolean,
            default:false
        },
        activeName:{
            type:String,
            default:'-1'
        },
    },
    computed: {
        i18n() {
            return this.$i18n.locale
        },
    },
    created() {
    },
    methods: {
        handleClick(val) { 
            this.$emit('handleChangeStatus',val)

        }
    }
}
</script>

<style lang="scss" scoped>
.tabPage {
    height: 56px;
    
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: var(--primary-color);
  color: #fff;
}
}
</style>